module.exports = __webpack_public_path__ + "static/img/instore_row4_icon3.d9aef1ee.png";